import styled from 'styled-components';
import { Link } from 'react-router-dom';
import TeamTable from '../../Team/components/AuthorTable';
import { Button, Spin } from 'antd';
import { useTranslation } from 'react-i18next';
import avater from '../../../assets/images/icons/user-avater.png';
import { useState, useEffect, useLayoutEffect } from 'react';
import { useSelector } from 'react-redux';
import { currentUser } from '../../../features/user/userSlice';
import { isTeamCteator } from '../../../utils/team';
import { getMyTeam, getMyTeamMember } from '../../../api/User';
import { getTeamMember } from '../../../api/Team';

const MyTeamContainer = styled.div`
  padding: 24px;
`;

const TeamNameContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const TeamName = styled.h3`
  /* min-height: 28px; */
  font-size: 22px;
  line-height: 22px;
  font-weight: 700;
`;

const TeamDescription = styled.div`
  width: 100%;
  position: relative;
  min-height: 60px;
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: #4b555e;
  padding-bottom: 40px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
`;

const Creater = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 12px;
  line-height: 12px;
  & > a {
    margin-left: 10px;
    color: #40a9ff;
  }
`;

const TeamInfo = styled.div`
  display: grid;
  grid-template-columns: 110px 1fr;
`;

const TeamAvatar = styled.img`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: #fff;
`;

const NoTeam = styled.div`
  width: 100%;
  height: 400px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
`;

const TeamButtonGroup = styled.div`
  width: 100%;
  max-width: 400px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 50px;
  @media screen and (max-width: 1024px) {
    grid-template-columns: 1fr;
    row-gap: 50px;
  }
`;

const MyTeam = () => {
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const [TeamData, setTeamData] = useState({});
  const [loading, setLoading] = useState(false);
  const [pageOptions, setPageOptions] = useState({
    currentPage: 1,
    perSize: 10,
    totalPage: 0,
  });

  const [hasTeam, setHasTeam] = useState(false);
  const [isCreator, setIsCreator] = useState(false);
  // team
  const _USER = useSelector(currentUser);

  useLayoutEffect(() => {
    if (_USER?.user?.team_id === 0) {
      setHasTeam(false);
    } else {
      setHasTeam(true);
    }
  });
  useLayoutEffect(() => {
    async function fetchdata() {
      if (hasTeam) {
        await fetchTeam();
        const _isCreator = await isTeamCteator(_USER.user.id);
        setIsCreator(_isCreator);
        if (_isCreator) {
          fetchTeamMember();
        } else {
          fetchTeamMemberUnMaster({
            team_id: _USER.user.team_id,
          });
        }
      }
      setLoading(false);
    }
    if (_USER?.user?.team_id === 0) {
      return;
    } else {
      fetchdata();
    }
  }, [hasTeam]);

  // useLayoutEffect(() => {
  //   fetchTeamMember();
  // }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const fetchTeam = async () => {
    setLoading(true);
    try {
      const { code, data } = await getMyTeam();
      if (code === '10000') {
        setTeamData(data);
      }
    } catch (error) {
      // console.log(error);
    }
    setLoading(false);
  };

  const fetchTeamMember = async () => {
    setLoading(true);
    try {
      const { code, data } = await getMyTeamMember();
      if (code === '10000') {
        setData(data.list);
        setPageOptions({
          currentPage: data.current_page,
          perSize: data.per_page,
          totalPage: data.total,
        });
      }
    } catch (error) {
      // console.log(error);
    }
    setLoading(false);
  };

  const fetchTeamMemberUnMaster = async ({ team_id }) => {
    setLoading(true);
    try {
      const { code, data } = await getTeamMember({ team_id });
      if (code === '10000') {
        setData(data.list);
        setPageOptions({
          currentPage: data.current_page,
          perSize: data.per_page,
          totalPage: data.total,
        });
      }
    } catch (error) {
      // console.log(error);
    }
  };

  return hasTeam ? (
    <MyTeamContainer>
      <Spin spinning={loading}>
        <TeamInfo>
          <TeamAvatar src={avater} />
          <TeamNameContainer>
            <TeamName>
              {TeamData.title}
              {TeamData.status === 0 ? '  ( Pending )' : null}
            </TeamName>
            <Creater>
              {t('user_center.MyTeam.Creator')}:
              <Link
                to={`/whiteHats/detail/${TeamData?.creator?.id}`}
                style={{
                  color: '#fff',
                }}
              >
                {TeamData?.creator?.name}
              </Link>
            </Creater>
          </TeamNameContainer>
        </TeamInfo>
        <TeamDescription>{TeamData.description}</TeamDescription>
        <TeamTable
          isAdmin={true}
          title={
            <>
              {t('user_center.MyTeam.team member')}
              {` ( ${data.length} )`}
            </>
          }
          header={true}
          isCreator={isCreator}
          data={data}
          isUser={true}
          fetchData={fetchTeamMember}
        />
        {/* <Button
          type="primary"
          style={{
            height: '42px',
            backgroundColor: '#18EAC4',
            color: '#0e0e0e',
            border: 'none',
          }}
        >
          <Link to={`/team/detail/${TeamData.id}`}>
            {t('TeamTable.button')}
          </Link>
        </Button> */}
      </Spin>
    </MyTeamContainer>
  ) : (
    <MyTeamContainer>
      <NoTeam>
        <p>{t('user_center.MyTeam.NoTeam')}</p>
        <TeamButtonGroup>
          <Button
            style={{
              height: '42px',
              backgroundColor: '#18EAC4',
              borderColor: '#18EAC4',
              color: '#000',
              borderRadius: '6px',
            }}
          >
            <Link to={'/team'}>{t('user_center.MyTeam.JoinTeam')}</Link>
          </Button>
          <Button
            style={{
              height: '42px',
              backgroundColor: '#18EAC4',
              borderColor: '#18EAC4',
              color: '#000',
              borderRadius: '6px',
            }}
          >
            <Link to={'/addteam'}>{t('user_center.MyTeam.CreateTeam')}</Link>
          </Button>
        </TeamButtonGroup>
      </NoTeam>
    </MyTeamContainer>
  );
};

export default MyTeam;
